import { fieldNames } from 'src/lib/constants'

export enum SliderFilterTestIDs {
  DECREMENT_FILTER_MAX_VALUE_BTN = 'decrement-slider-max-value-btn',
  DECREMENT_FILTER_MIN_VALUE_BTN = 'decrement-slider-min-value-btn',
  INCREMENT_FILTER_MAX_VALUE_BTN = 'increment-slider-max-value-btn',
  INCREMENT_FILTER_MIN_VALUE_BTN = 'increment-slider-min-value-btn',
  SLIDER_FILTER = 'slider-filter',
}

export enum SliderUnit {
  FEET = 'feet',
  FEET_INCHES = 'feet-inches',
}

export const getUnitForField = (label: fieldNames) => {
  switch (label) {
    case fieldNames.DEPTH_OF_PLAN:
    case fieldNames.WIDTH_OF_PLAN:
      return SliderUnit.FEET_INCHES
    case fieldNames.SQFT_OF_HOME_CONDITIONED_SPACE:
    case fieldNames.SQFT_HOME:
    default:
      return SliderUnit.FEET
  }
}

export const getFeetInches = (value: number): string => {
  if (value !== undefined && value !== null) {
    const feet = Math.floor(value / 12)
    const inches = value % 12
    return `${feet}'${inches}"`
  }
  return ''
}

export const getFeet = (value: number): string => `${value} ft²`

const cache: Map<string, string> = new Map()

export const getFormattedValue = (value: number, field: fieldNames): string => {
  const unit = getUnitForField(field)

  const cacheKey = `${value}_${unit}`

  if (cache.has(cacheKey)) return cache.get(cacheKey)!

  let formattedValue = ''

  switch (unit) {
    case SliderUnit.FEET_INCHES:
      formattedValue = getFeetInches(value)
      break
    case SliderUnit.FEET:
      formattedValue = getFeet(value)
      break
  }

  cache.set(cacheKey, formattedValue)
  return formattedValue
}
